const PRESERVE_KEYS = [
  'device:id',
  'audio:speaker',
  'audio:microphone',
  'audio:ringtone',
  'ui:background',
  'ui:telAction',
  'ui:autoStartCallAssistant',
];

const clearLocalState = () => {
  try {
    const preserved = {};
    for (const k of PRESERVE_KEYS) {
      const v = localStorage.getItem(k);
      if (v !== null) preserved[k] = v;
    }
    localStorage.clear();
    for (const [k, v] of Object.entries(preserved)) localStorage.setItem(k, v);
    sessionStorage.clear();
  } catch {
    /* disabled */
  }
};

export const handleLogout = () => Promise.resolve(clearLocalState());

export const clearCacheAndReset = () => {
  clearLocalState();
  if (typeof window !== 'undefined') window.location.reload();
  return Promise.resolve();
};

// Electron exposed OS suspend/resume so the app could tear down sockets
// during sleep and reinit on wake. The browser has no OS-sleep signal —
// `visibilitychange` (tab switch) is NOT equivalent and would cause
// constant tear-down/reconnect on every focus change. The honest
// translation is connectivity loss: fire suspend on `offline` and
// resume on `online`. The downstream sagas (socket/SSE disconnect,
// token-refresh-timer cancel, full re-init via initializeApp) are the
// right behavior for both scenarios.
export const onSuspend = (callback) => {
  if (typeof window === 'undefined') return () => {};
  const handler = () => callback();
  window.addEventListener('offline', handler);
  return () => window.removeEventListener('offline', handler);
};

export const onResume = (callback) => {
  if (typeof window === 'undefined') return () => {};
  const handler = () => callback();
  window.addEventListener('online', handler);
  return () => window.removeEventListener('online', handler);
};
